module.exports = __webpack_public_path__ + "static/media/ax.e939bf2e.svg";